import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/connect');
export const createProduct = (input) => req('POST', `/products`, { body: input });
export const products = () => req('GET', `/products`);
export const updateProduct = (id, input) => req('PATCH', `/products/${id}`, { body: input });
export const createInvitation = (input) => req('POST', `/invitations`, { body: input });
export const invitations = () => req('GET', `/invitations`);
export const invitationById = (id, token) => req('GET', `/invitations/${id}?token=${encodeURIComponent(token)}`);
export const acceptInvitation = (id, input) => req('POST', `/invitations/${id}/accept`, { body: input });
export const setPropertyTypeMappings = (connectionId, propertyTypeMappings) => req('PUT', `/connections/${connectionId}/property-type-mappings`, {
    body: { propertyTypeMappings },
});
export const connectionsById = (id) => req('GET', `/connections/${id}`);
export const productsById = (id) => req('GET', `/products/${id}`);
export const connectionsFrom = () => req('GET', `/connections/from`);
export const connections = () => req('GET', `/connections`);
export const getMappingCreditorLink = (id) => req('GET', `/mappings/${id}/creditor-link`);
export const getCaseMappingsOnCase = (id) => req('GET', `/mappings/by-case-id/${id}`);
export const getCaseMapping = (id) => req('GET', `/mappings/${id}`);
export const getCaseMappingsOnConnection = (connectionId) => req('GET', `/connections/${connectionId}/mappings`);
export const getEntityMappings = (id) => req('GET', `/mappings/by-case-id/${id}/entity-mappings`);
//# sourceMappingURL=connect.js.map